import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import type { Option } from 'modules/types'
import { useGetWorkspacesFromImportRequests } from 'services/import-requests/hooks/useGetWorkspacesFromImportRequests'

interface ImportRequestWorkspacesFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const ImportRequestWorkspacesFilter = ({ onApply, onReset }: ImportRequestWorkspacesFilterProps) => {
  const workspacesQuery = useGetWorkspacesFromImportRequests()

  const options =
    workspacesQuery.data?.data.map(workspace => ({
      label: workspace.name,
      value: workspace._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Workspaces"
      loading={workspacesQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search workspaces"
    />
  )
}
